import { graphql, useStaticQuery } from "gatsby"
import React from "react"

import BookCatalogOrganism from "@organisms/BookCatalog/BookCatalog"

const BookCatalog = () => {
  const data = useStaticQuery(
    graphql`
      {
        allRichieBook(sort: { publication_date: DESC }) {
          nodes {
            id
            title
            author
            has_audio
            has_epub
            cover_url
            cover_width
            cover_height
            extra {
              category
            }
          }
        }
      }
    `
  )

  return (
    <BookCatalogOrganism
      books={data.allRichieBook?.nodes
        .filter((node) => node.id !== "dummy")
        .map((node) => {
          return {
            ...node,
            cover_url: `${node?.cover_url}?width=308`,
          }
        })}
    />
  )
}

export const query = graphql`
  fragment BookCatalog on WpBlockAcfBookCatalog {
    __typename
  }
`

export default BookCatalog
